module.exports = __webpack_public_path__ + "img/project-edu-01.2ddade4e.png";